import { DataLayerWrapper } from './DataLayerWrapper';
import { GoogleAnalyticsClient } from '../../commonv2/modules/analytics';
import { GlobalStatesV3 } from '../states/GlobalStatesV3';

export const ApplicationEvents = {
  async applicationComplete(event: string, order_id: number | undefined) {
    const { currentUser } = GlobalStatesV3.currentUser;
    DataLayerWrapper.push({
      event,
      user_id: currentUser.id,
      email: currentUser.email,
      order_id,
    });
    GoogleAnalyticsClient.sendGaEvent('application', 'application_complete', 'view_application_complete', 0);
  },
};
